// extracted by mini-css-extract-plugin
export default {"sticky":"DirectFormTable_sticky__fy-Bx","stickyTop":"DirectFormTable_stickyTop__3vlY1"};